import React from "react";
import Header from "../header/index";
import Body from "../body/index";
import Footer from "../footer/index";


function Home() {
  return ( <div className="flex flex-col w-full ">
    <div>
        <Header />
    </div>
    <div className="mx-auto px-10">
        <Body />
    </div>
    <div>
        <Footer />
    </div>
  </div>
  );
}

export default Home;